const isProduction = process.env.REACT_APP_BUILD_TYPE === 'production';
const isStaging = process.env.REACT_APP_BUILD_TYPE === 'staging';

let publicbaseUrl = 'https://getset4education.co.uk';
let stripeKey = 'pk_live_4kM5QVsO0YETlXg1oaWyzieX';
if (!isProduction) {
  publicbaseUrl =
    'https://getset4pe-getset4education-public-v1.uat.avamae.co.uk';
  stripeKey = 'pk_test_VdhJmdlQLXHs2kZzwkyrvc4Q';
}

export const PUBLIC_SITE_URL = publicbaseUrl;
export const STRIPE_KEY = stripeKey;

export enum AppPath {
  ROOT = '/',
  DASHBOARD = '/dashboard',
  FORGOTTEN_PASSWORD = '/forgotten-password',
  RESET_PASSWORD = '/reset-password-schooluser',
  SET_PASSWORD = '/set-password-schooluser',
  NEW_SUBSCRIPTION = '/subscriptions/add-subscriptions',
  NEW_FREE_TRIAL = '/subscriptions/add-free-trial',
  UPGRADE_SUBSCRIPTION = '/upgrade-subscription',
  PROFILE = '/profile',
  MANAGEUSERS = '/manage-users',
  MANAGESCHOOL = '/manage-school',
  INVOICES = '/invoices',
  INVOICE_PAGE = 'template/subscription-invoice',
  MY_DOCUMENTS = '/documents',
  SIGN_IN = '/sign-in',
  SUBSCRIBE = '/subscribe',
  SUBSCRIBE_FREE_TRIAL = '/free-trial',
  MEMBERSHIP_OPTIONS = '/membership-options',
  MFA_CHALLENGE = '/mfa-challenge',
}

export enum NewSubscriptionPath {
  PAYMENT_DETAILS = '/payment-details',
  PAYMENT_TYPE = '/payment-type',
  ROOT = '/',
}

export enum SubscriptionTypes {
  STANDARD = 'Standard',
  INVESTEMENT = 'Investment',
}

export enum PaymentTypes {
  PAY_BY_CARD = 'Pay by card',
  PAY_BY_INVOICE = 'Pay by Invoice',
}

// export enum SubscriptionDuration {
//   ONE_YEAR = '1 Year',
//   THREE_YEARS = '3 Year',
//   FIVE_YEARS = '5 Year',
// }

export const ERROR_MESSAGE: string =
  'Oops, something went wrong. Please try again later.';
export const NO_ACCESS_MESSAGE: string =
  "You don't have permissions to access this page";
export const NOT_FOUND_PAGE: string = 'Page not found';
export const SESSION_EXPIRED_MESSAGE: string =
  'Your session has expired. Please sign in again.';
/** For a code the server refused, or one covering none of the chosen subjects. */
export const INVALID_PROMO_CODE_MESSAGE: string = 'Invalid promo code';

export const FALLBACK_ERROR_MESSAGE: string =
  'Please try again. If the error persists, please contact support.';

// AB#210766 - client-agreed policy: min 10 chars incl. lowercase, uppercase, number and special char.
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9\s])/;
export const PASSWORD_MATCH_POLICY_ERROR_MESSAGE =
  'Password must be at least 10 characters and include a lowercase letter, an uppercase letter, a number and a special character';
